import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "cooperative-partner"
};
const _hoisted_2 = ["src"];
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
// import required modules
import { Autoplay } from "swiper/modules";
export default /*#__PURE__*/_defineComponent({
  __name: 'cooperative-partner',
  setup(__props) {
    const modules = [Autoplay];
    const partnerLogoList = [["https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-1-1.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-1-2.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-1-3.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-1-4.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-1-5.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-1-6.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-1-7.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-1-8.jpg"], ["https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-2-1.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-2-2.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-2-3.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-2-4.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-2-5.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-2-6.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-2-7.jpg", "https://img2.qiuwenxinli.com/official-website/index/cooperative-partner-logo-2-8.jpg"]];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(partnerLogoList, (logos, index) => {
        return _createVNode(_unref(Swiper), {
          style: {
            'transition-timing-function': 'linear'
          },
          slidesPerView: 'auto',
          spaceBetween: 30,
          modules: modules,
          slidesPerGroup: 3,
          loop: true,
          speed: 10000,
          freeMode: true,
          allowTouchMove: false,
          autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          class: "cooperative-partner-swiper",
          key: index
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logos, (item, index) => {
            return _openBlock(), _createBlock(_unref(SwiperSlide), {
              class: "cooperative-partner-swiper-item",
              key: index
            }, {
              default: _withCtx(() => [_createElementVNode("img", {
                src: item
              }, null, 8, _hoisted_2)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 2
        }, 1024);
      }), 64))]);
    };
  }
});